import { render, staticRenderFns } from "./PopUpVideo.vue?vue&type=template&id=3b05c0bb&"
import script from "./PopUpVideo.vue?vue&type=script&lang=js&"
export * from "./PopUpVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports